export default class ImageValueType {
  imagePath: string
  text: string
  ':type': string

  constructor(data: any) {
    this.imagePath = data.imagePath
    this.text = data.text
    this[':type'] = data[':type']
  }
}
